// https://codesandbox.io/p/sandbox/material-ui-5-hamburger-menu-navigation-fms85m

import React, { useState, useContext, useEffect, } from "react";
import { styled, alpha } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import HomeIcon from '@mui/icons-material/Home';
import { Link } from "react-router-dom";

//drawer elements used
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import Divider from "@mui/material/Divider";
import InputBase from "@mui/material/InputBase";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Chip from "@mui/material/Chip";
import DescriptionIcon from "@mui/icons-material/Description";
import DeckContext from "../../../store/DeckContext";
import ThemeSwitcher from "./ThemeSwitcher";
import { useTheme } from '../../../store/ThemeContext';


// import { navLinks, currentVersion, } from "../../../assets/constants/index.js";

// import { LGDK_LOGO_NOTEXT_BLUE, } from "../../../assets/images";

/*
How to enable ListItemButton to use React Router v6 Link?
https://stackoverflow.com/questions/71822728/how-to-enable-listitembutton-to-use-react-router-v6-link

*/

const StyledSearch = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.primary.light, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.25)
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto"
  }
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch"
    }
  }
}));

//search as JSX
const search = (
  <StyledSearch>
    <SearchIconWrapper>
      <SearchIcon />
    </SearchIconWrapper>
    <StyledInputBase
      placeholder="Rechercher…"
      inputProps={{ "aria-label": "search" }}
    />
  </StyledSearch>
);


const HomeAppBar = () => {
  //react useState hook to save the current open/close state of the drawer, normally variables dissapear afte the function was executed
  const [open, setState] = useState(false);
  const { isDark, toggleTheme } = useTheme();

  let deckContext = useContext(DeckContext);

  //function that is being called every time the drawer should open or close, the keys tab and shift are excluded so the user can focus between the elements with the keys
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    //changes the function state according to the value of open
    setState(open);
  };

  return (
    <AppBar position="static" className={`bg-card-bg text-[rgb(var(--color-primary))]`}>
      <Container maxWidth="xl" disableGutters="true">
        <Toolbar>
          {/* 
          <Typography>
            <a href="/">
              <img src={LGDK_LOGO_NOTEXT_BLUE} alt="logo" width={64} />
            </a>
          </Typography>
          <Typography variant="secondary" sx={{ flexGrow: 1, fontWeight: 700, color: "secondary.contrastText" }}>
            <div>
              {currentVersion.product} | {currentVersion.subProduct}
            </div>
          </Typography>
          */}

          <IconButton
            edge="start"
            color="inherit"
            aria-label="home"
            href="/"
            sx={{
              mr: 2,
              display: {
                xs: "block",
                /* md: "none", hidden if device >= md */
              }
            }}
          >
            <HomeIcon />
          </IconButton>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer(true)}
            sx={{
              mr: 2,
              display: {
                xs: "block",
                /* md: "none", hidden if device >= md */
              }
            }}
          >
            <MenuIcon />
          </IconButton>
          <Box
            component="div"
            sx={{
              display: {
                xs: "none",
                md: "block",
              }
            }}
          >
            {/* 
            {search}            
            */}
          </Box>



          {/* The outside of the drawer */}
          <Drawer
            //from which side the drawer slides in
            anchor="right"
            //if open is true --> drawer is shown
            open={open}
            //function that is called when the drawer should close
            onClose={toggleDrawer(false)}
          //function that is called when the drawer should open
          // onOpen={toggleDrawer(true)}
          >
            {/* The inside of the drawer */}
            <Box
              className="bg-[rgb(var(--color-primary))]"
              sx={{
                p: 2,
                height: 1,
              }}
            >
              {/* when clicking the icon it calls the function toggleDrawer and closes the drawer by setting the variable open to false */}
              <IconButton sx={{ mb: 2 }}>
                <CloseIcon onClick={toggleDrawer(false)} />
              </IconButton>

              <Divider sx={{ mb: 2 }} />
              {/* 
              search}            
              */}
              <Box sx={{ mb: 2 }} className="bg-[rgb(var(--color-primary))]">
                {/* on itère sur les liens de navigations intrapage : ajout du lien 
               https://stackoverflow.com/questions/47206639/how-to-add-a-link-to-a-list-in-material-ui-1-0
               */}
                {deckContext.current_deck.navlinks && deckContext.current_deck.navlinks.map(
                  (item, index) => (
                    <>
                      {/* on teste si href interne (#) : composant "a" sinon "Link" */}
                      <ListItemButton key={index} component={item.url.startsWith('#') ? "a" : Link} href={`${item.url}`} to={`${item.url}`} className={!item.enabled && "disabled-link"}  >
                        {item.img ? (
                          <div className="w-6 h-6 rounded-xl bg-[rgb(var(--color-bg-pills))] flex items-center justify-center overflow-hidden group-hover:bg-[rgb(var(--color-primary))] transition-colors shrink-0 gap-4">

                            <img
                              src={item.img}
                              alt={`Drapeau ${item.img}`}
                              className={`w-full h-full object-cover transition-transform ${item.enabled ? 'group-hover:scale-110' : 'grayscale'}`}
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentNode.innerHTML = '🌐';
                              }}
                            />
                          </div>

                        ) : (
                          <span className="text-2xl">&#127822;</span>
                        )}
                        <ListItemText primary={`${item.label}`} className="ml-4 font-bold text-white dark:text-gray-800" />
                        {/* <Chip label={item.enabled ? "disponible" :"prochainement"} size="small"></Chip> */}
                      </ListItemButton>
                    </>
                  ))}
              </Box>

            </Box>
          </Drawer>
          {/* Switch Mode Sombre */}
          {isDark ?
            <button onClick={toggleTheme} className="mt-2 hover:scale-110 transition-transform">☀️</button>
            :
            <button onClick={toggleTheme} className="mt-2 hover:scale-110 transition-transform">🌙</button>
          }

        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default HomeAppBar